'use strict';
module.exports = function cleanDOMId(s) {
	return s.replace(/[^A-Za-z0-9_-]/g, '_');
};
